import { connect } from 'react-redux';

import { NeighborhoodLayout, INeighborhoodLayoutStateProps } from './index';
import { IState } from '../../../store';

function mapStateToProps(state: IState): INeighborhoodLayoutStateProps {
  return {
    neighbourhoodList: state.villageData.village.neighbourhoodList ?? [],
  };
}

export const NeighborhoodLayoutContainer = connect(mapStateToProps)(NeighborhoodLayout);
